import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { useCustomToast } from 'hooks';
import { updateCompanyDetails } from 'modules/settings/api';

export const useMutationCompanyDetails = () => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  const { successToast, errorToast } = useCustomToast();

  const { mutateAsync: updateCurrentCompanyDetails, isLoading: isMutatingCompanyDetails } =
    useMutation(updateCompanyDetails, {
      onSuccess: () => {
        queryClient.invalidateQueries(QUERY_KEYS.SETTINGS_PROFILE_COMPANY_SETTINGS);
        successToast(t('Your company details are successfully saved.'));
      },
      onError: (res: any) => {
        errorToast();
      },
    });

  return {
    updateCurrentCompanyDetails,
    isMutatingCompanyDetails,
  };
};
